import axios from 'axios'

const baseURL = (process.env.REACT_APP_API_URL || '').trim()

const apiClient = axios.create({
  baseURL: baseURL.endsWith('/') || baseURL === '' ? baseURL : baseURL + '/',
})

export default apiClient
